import { useEffect } from 'react';

/** Narrow responsive layouts always use cards, without overwriting the saved
 * desktop view preference in localStorage. */
export function useMobileGridView<T>(setView: (value: T) => void, gridValue: T): void {
  useEffect(() => {
    const media = window.matchMedia('(max-width: 767px)');
    const enforce = () => { if (media.matches) setView(gridValue); };
    enforce();
    media.addEventListener('change', enforce);
    return () => media.removeEventListener('change', enforce);
  }, [gridValue, setView]);
}
